import type { ApiClientV2Default } from 'utils/api-client/api-client.utils'
import { FromSwagger } from 'types/helpers'

import { AccountAttributes } from 'types/__generated__/api'

import { ACTIVE_PROFILES } from '@elo-kit/constants/profile.constants'

export type ActiveProfileType = (typeof ACTIVE_PROFILES)[keyof typeof ACTIVE_PROFILES]

const BASE_URL = (accountType: ActiveProfileType) => `/accounts/${accountType}`

export type AccountResponse = FromSwagger<AccountAttributes>

export interface LinkLegalEntityParams {
  legalEntityType: string
  legalEntityId: string
}

export const createAccountsApi = ({ GET, PATCH }: ApiClientV2Default) => ({
  fetchAccount: (accountType: ActiveProfileType) => GET<AccountResponse>(`${BASE_URL(accountType)}`),
  linkLegalEntity: (accountType: ActiveProfileType, data: LinkLegalEntityParams) =>
    PATCH<AccountResponse>(`${BASE_URL(accountType)}/link_legal_entity`, {
      data: {
        type: 'accounts',
        attributes: data,
      },
    }),
})

export type AccountsApi = ReturnType<typeof createAccountsApi>
